var map = {
	"./barcode.svg": "vxWv",
	"./cancel.svg": "pdRo",
	"./chat.svg": "VxLz",
	"./dashboard.svg": "BCGP",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./import.svg": "XteN",
	"./info.svg": "Yfis",
	"./list-confirm.svg": "UG1V",
	"./list-transfer.svg": "tIzv",
	"./list.svg": "vuHp",
	"./matching.svg": "4DYc",
	"./notification.svg": "2V/f",
	"./password.svg": "QjmH",
	"./price.svg": "Y2tI",
	"./revenue.svg": "CRqx",
	"./search.svg": "Bx0U",
	"./table.svg": "oSYw",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 11